import type {AppThunk} from '../../../../actions/types'
import {getTabsArg} from '../../../../rest/tabs'
import type {LoadedEndpoints} from '../../../../routes/loadEndpoint'
import {loadEndpoint} from '../../../../routes/loadEndpoint'
import {restApi} from '../../../../services/rest'
import type {AgentTypeId} from '../../../../types'
import {getTabParamsKey} from '../../../../utils/tabs'

export const preloadAgentTypePage =
  (agentTypeId: AgentTypeId): AppThunk<LoadedEndpoints> =>
  dispatch => [
    dispatch(
      loadEndpoint(
        restApi.endpoints.getTabs,
        getTabsArg(getTabParamsKey({agentTypeId}), true, false),
      ),
    ),
  ]
